export const LockType = {
    LoginLock: 'loginLock',
    OrderingLock: 'orderingLock'
} as const;

export type LockTypeKeys = (typeof LockType)[keyof typeof LockType];
